import styled from 'styled-components'
import { ReactNode, useContext, useRef, useState } from 'react'
import { PortalTooltipContext } from 'ui'
import { CopilotContext } from '../../context'
import { Preset, PresetsContainer } from './style'
import LoaderSnake from 'ui/src/components/loader/snake'
import Button from 'ui/src/components/controls/button'
import { uniqueId } from 'lodash'
import { CopilotUploadPreset } from 'shared/types/copilot'
import { SIDEBAR_PRESET_SIZE } from '../../constants'

type Props = {
    className?: string
    children?: ReactNode
    presets: CopilotUploadPreset[]
    cursor?: string
    fetchMore: (cursor?: string) => Promise<void>
}

const StyledButton = styled(Button)`
    margin: 5px 5px 0;
    width: calc(100% - 10px);
`

const CopilotSidebarPresets = ({ className, children, presets, cursor, fetchMore }: Props) => {
    const idRef = useRef(uniqueId('copilot-sidebar-presets'))
    const { activePresetId } = useContext(CopilotContext)
    const [isLoading, setIsLoading] = useState(false)

    const loadMorePresets = async () => {
        setIsLoading(true)
        await fetchMore(cursor)
        setIsLoading(false)
        console.log('presets: ', presets)
    }

    return (
        <PortalTooltipContext>
            <div className={className}>
                {children}

                <PresetsContainer $hasMore={!!cursor}>
                    {presets.map((preset, i) => {
                        const active = preset.id === activePresetId

                        return (
                            <Preset
                                $active={active}
                                preset={preset}
                                key={`${idRef.current}${preset.id}${i}`}
                                showEllipsisMenu
                                size={SIDEBAR_PRESET_SIZE}
                            />
                        )
                    })}
                </PresetsContainer>

                {isLoading && <LoaderSnake size="medium" />}

                <StyledButton
                    color={cursor ? '#2e2e2e' : '#6c6c6c'}
                    gradient={cursor ? 'indigo-purple' : undefined}
                    onClick={loadMorePresets}
                    size={SIDEBAR_PRESET_SIZE}
                    disabled={isLoading || !cursor}
                >
                    Load More
                </StyledButton>
            </div>
        </PortalTooltipContext>
    )
}

export default CopilotSidebarPresets
